export default __webpack_public_path__ + "static/media/rs-arte-4.02493660.webp";